module.exports = __webpack_public_path__ + "static/img/upload.58f26bdd.png";